
<div class="constructionDowntimeImage" >
<div class="errorMsgDisplay pt-4" *ngFor="let errorMsg of errorMsgDTs">{{errorMsg.errorMsg}}</div>
</div>

